import React, { useCallback, useEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

function useSizeTracking(elementRef) {
  let shouldTrack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const [bcr, setBcr] = React.useState(undefined);
  const callbackRef = React.useRef();
  const handleResize = useCallback(entries => {
    if (callbackRef.current) {
      window.cancelIdleCallback(callbackRef.current);
    }

    const firstEntry = entries[0];

    if (!firstEntry) {
      return;
    }

    callbackRef.current = window.requestIdleCallback(() => {
      const elementBCR = firstEntry.contentRect;
      setBcr(elementBCR);
    }, {
      timeout: 200
    });
  }, []);
  useEffect(() => {
    if (!shouldTrack) {
      return undefined;
    }

    const {
      current: el
    } = elementRef;

    if (!el) {
      console.error('useSizeTrackign: Cannot reference requested element');
      return undefined;
    }

    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(el);
    return () => {
      resizeObserver.disconnect();
    };
  }, [elementRef, handleResize, shouldTrack]);
  return bcr;
}

export { useSizeTracking as default };
//# sourceMappingURL=useSizeTracking.js.map
